import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserRoutingModule } from './user-routing.module';
import { UserComponent } from './user.component';
import { UserSkillsComponent } from './user-skills/user-skills.component';
import { UserGridComponent } from './user-grid/user-grid.component';
import { ManageSettingsComponent } from './manage-settings/manage-settings.component';
// Adding relevent modules from kendo. TO DO :- Once all the modules needed are finalized. Export them in root of the application.
import { GridModule } from '@progress/kendo-angular-grid';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { PopupModule } from '@progress/kendo-angular-popup';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { TimePickerModule } from '@progress/kendo-angular-dateinputs';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { NotificationModule } from '@progress/kendo-angular-notification';

import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserAvailabilityComponent } from './user-availability/user-availability.component';
import { UserSettingsComponent } from './user-settings/user-settings.component';
import { UserAdditionalSettingsComponent } from './user-additional-settings/user-additional-settings.component';
import { NgbAccordionModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

// import { MultiDatePicker } from './multi-date-picker/multi-date-picker'
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { UserLobbySettingsComponent } from './user-lobby-settings/user-lobby-settings.component';
import { NgxSpinnerModule } from "ngx-spinner";

@NgModule({
  declarations: [UserComponent, UserSkillsComponent, UserGridComponent, ManageSettingsComponent, UserAvailabilityComponent, UserSettingsComponent, UserAdditionalSettingsComponent, UserLobbySettingsComponent],
  imports: [
    CommonModule,
    FormsModule,
    UserRoutingModule,
    GridModule,
    NgbDatepickerModule,
    NotificationModule,
    InputsModule,
    PopupModule,
    DialogsModule,
    HttpClientModule,
    DropDownsModule,
    DateInputsModule,
    TooltipModule,
    TimePickerModule,
    LayoutModule,
    ReactiveFormsModule,
    NgbDropdownModule,
    NgbAccordionModule,
    SharedModule,
    NgxSpinnerModule,
    NgMultiSelectDropDownModule.forRoot(),
  ],
})
export class UserModule { }
